import parseHTML, { domToReact } from 'html-react-parser';
import React from 'react';
import { ANCHOR_TAG, TARGET_BLANK } from '../constants';

function parseTextBlock(config) {
  const { html, LinkWrapper, useTargetBlank } = config;

  const options = {
    replace: domNode => {
      const { attribs, children, name: tagName } = domNode;
      if (tagName === ANCHOR_TAG) {
        const target = useTargetBlank ? TARGET_BLANK : attribs.target;

        return LinkWrapper ? (
          <LinkWrapper {...attribs} target={target}>
            {domToReact(children, options)}
          </LinkWrapper>
        ) : (
          domNode
        );
      }
      return null;
    }
  };

  return parseHTML(html, options);
}

export default parseTextBlock;
